module.exports = __webpack_public_path__ + "img/logo.9f62dc63.png";